import { Checkbox, Row } from 'antd';
import styled from 'styled-components';
import { Icon } from 'ui';

export const StyledRow = styled(Row)`
  display: block;
  > div {
    height:100%;
  }
`;

export const IconWrapper = styled.div`
  display: inline;
  color: ${p => p.theme.colors.theme};
  font-weight: 500;
`;

export const StyledInfoIcon = styled(Icon)`
  margin-right: 10px;
  color: ${p => p.theme.colors.theme};
`;

export const InfoRow = styled(Row)`
  margin-bottom: 10px;
  text-transform: uppercase;
`;

export const StyledSelectAllRow = styled(Row)`
  margin: 15px 0;
  ${p => p.marginLeft && `margin-left: ${p.marginLeft};`}
  > .ant-checkbox-wrapper > .ant-checkbox {
    margin-right: 12px;
  }
`;

export const SelectAllCheckbox = styled(Checkbox)`
  margin-left: ${p => p.marginLeft};
`;
